(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const neverShowOnSticky = document.querySelectorAll('[data-scroll]');
  const stickyHeader = document.querySelector('[data-sticky]');
  const headerHideSpace = document.querySelector("header");
  const defaultNav = document.getElementById('default-nav');
  const stickyNav = document.getElementById('sticky-nav');

  function checkScreenSize() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth;
    const scrollY = window.scrollY || window.pageYOffset;

    if (screenWidth > 1200 && scrollY < 100) {
      // show default nav / hide sticky
      neverShowOnSticky.forEach(navItem => navItem.style.removeProperty('display'));

      if (stickyHeader) stickyHeader.style.setProperty('display', 'none', 'important');

      if (defaultNav) {
        defaultNav.setAttribute('aria-hidden', 'false');
        defaultNav.removeAttribute('tabindex');
      }
      if (stickyNav) {
        stickyNav.setAttribute('aria-hidden', 'true');
        stickyNav.setAttribute('tabindex', '-1');
      }

      if (headerHideSpace) headerHideSpace.style.removeProperty('top');

    } else if (screenWidth > 1200 && scrollY > 100) {
      // hide default nav / show sticky
      neverShowOnSticky.forEach(navItem => navItem.style.setProperty('display', 'none', 'important'));

      if (stickyHeader) stickyHeader.style.removeProperty('display');

      if (defaultNav) {
        defaultNav.setAttribute('aria-hidden', 'true');
        defaultNav.setAttribute('tabindex', '-1');
      }
      if (stickyNav) {
        stickyNav.setAttribute('aria-hidden', 'false');
        stickyNav.removeAttribute('tabindex');
      }

      if (headerHideSpace) headerHideSpace.style.setProperty('top', 0);
    }
  }

  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
  window.addEventListener("scroll", checkScreenSize);

  // ---- Megamenu keyboard & click behavior ----
  [defaultNav, stickyNav].forEach(nav => {
    if (!nav) return;

    const dropdownLinks = nav.querySelectorAll('.nav-item.dropdown.megamenu > a');

    dropdownLinks.forEach(link => {
      const parentLi = link.parentElement;
      const dropdownUl = parentLi.querySelector('.dropdown-menu');

      const closeAllMenus = () => {
        nav.querySelectorAll('.nav-item.dropdown.megamenu').forEach(item => {
          item.classList.remove('show');
          const ul = item.querySelector('.dropdown-menu');
          if (ul) ul.classList.remove('show');
          const itemLink = item.querySelector('a');
          if (itemLink) itemLink.setAttribute('aria-expanded', 'false');
        });
      };

      const toggleMenu = () => {
        const isOpen = parentLi.classList.contains('show');
        if (!isOpen) {
          closeAllMenus();
          parentLi.classList.add('show');
          if (dropdownUl) dropdownUl.classList.add('show');
          link.setAttribute('aria-expanded', 'true');
        } else {
          parentLi.classList.remove('show');
          if (dropdownUl) dropdownUl.classList.remove('show');
          link.setAttribute('aria-expanded', 'false');
        }
      };

      link.addEventListener('click', e => {
        e.preventDefault();
        toggleMenu();
      });

      link.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleMenu();
        }
      });
    });

    document.addEventListener('click', e => {
      if (!e.target.closest('.nav-item.dropdown.megamenu')) {
        nav.querySelectorAll('.nav-item.dropdown.megamenu').forEach(item => {
          item.classList.remove('show');
          const ul = item.querySelector('.dropdown-menu');
          if (ul) ul.classList.remove('show');
          const itemLink = item.querySelector('a');
          if (itemLink) itemLink.setAttribute('aria-expanded', 'false');
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
